export default __webpack_public_path__ + "files/f0ed40c1c7c4d880a63ee27219899038.svg";